<template>
    <div class="titlebar-box">
        <span>{{ mTitlebar.title }}</span>
        <div class="divider"></div>
    </div>
</template>

<script>
export default {
    name: "TitleBarView",
    props: ['titlebar'],
    data() {
        return {
            mTitlebar: this.titlebar
        }
    },
    methods: {
        getSelectStyle(index) {
            if (index == this.currentIndex) {
                return 'color:' + this.navigationbar.color_select + ';'
                    + 'font-weight:bold;'
            } else {
                return 'color:' + this.navigationbar.color_default + ';'
                    + 'font-weight:normal;'
            }
        }
    }
}
</script>

<style scoped lang="less">
.titlebar-box {
    position: relative;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-weight: bold;
    // background-color: #888;
}

.divider {
    width: 100%;
    height: 1.5px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #f5f5f5;
}
</style>